import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDemo2Ctx } from '../Demo2Context';
import Demo2Nav from '../layout/Demo2Nav';
import bgVideo from '../../../assets/bg1.mp4';

export default function Demo2Login() {
    const navigate = useNavigate();
    const { toast } = useDemo2Ctx();
    const [showPw, setShowPw] = useState(false);
    const [checked, setChecked] = useState(true);

    const doLogin = () => {
        toast('로그인 중...', 'success');
        setTimeout(() => navigate('/demo2/web/dashboard'), 650);
    };

    return (
        <>
            <Demo2Nav />
            <div
                className="sian sian-auth"
                style={{
                    marginTop: 'var(--demo-nav-h)',
                    minHeight: 'calc(100vh - var(--demo-nav-h))',
                    background: 'transparent',
                }}
            >
                <div
                    style={{
                        position: 'fixed',
                        inset: 0,
                        zIndex: 0,
                        overflow: 'hidden',
                    }}
                >
                    <video
                        autoPlay
                        muted
                        loop
                        playsInline
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                        }}
                    >
                        <source src={bgVideo} type="video/mp4" />
                    </video>
                    <div
                        style={{
                            position: 'absolute',
                            inset: 0,
                            background: 'rgba(0,20,10,0.52)',
                        }}
                    />
                </div>
                <div className="auth-logo fade-up">
                    <div className="auth-logo-mark">
                        <i className="ri-tree-line" />
                    </div>
                    <div>
                        <div className="auth-logo-name">
                            <em>AIS</em> × 수프로
                        </div>
                        <div className="auth-logo-sub">수목관리 시스템</div>
                    </div>
                </div>

                <div
                    className="auth-card fade-up"
                    style={{ animationDelay: '.08s' }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginBottom: 14,
                        }}
                    >
                        <span className="lh-badge">
                            <span className="dot" />
                            한국토지주택공사 전용 플랫폼
                        </span>
                    </div>
                    <div
                        className="auth-card-title"
                        style={{ textAlign: 'center' }}
                    >
                        로그인
                    </div>
                    <div
                        className="auth-card-sub"
                        style={{ textAlign: 'center' }}
                    >
                        AI 기반 수목 생육·관개 통합관리 플랫폼에 오신 것을
                        환영합니다
                    </div>

                    <div className="sso-row" style={{ marginBottom: 18 }}>
                        <button
                            className="sso-btn"
                            onClick={() => toast('수프로 계정 연동', 'success')}
                        >
                            <i className="ri-leaf-line" /> 수프로 파트너
                            계정으로 로그인
                        </button>
                    </div>
                    <div className="divider-text" style={{ marginBottom: 18 }}>
                        <span>또는 아이디로 로그인</span>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 15,
                        }}
                    >
                        <div className="form-group">
                            <label className="form-label">아이디</label>
                            <div className="icon-field">
                                <i className="ri-user-3-line field-ico" />
                                <input
                                    type="text"
                                    className="form-input"
                                    placeholder="ID를 입력하세요"
                                    defaultValue="lh_manager01"
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="form-label">비밀번호</label>
                            <div className="pw-wrap">
                                <input
                                    type={showPw ? 'text' : 'password'}
                                    className="form-input"
                                    placeholder="비밀번호 입력"
                                    defaultValue="demo1234!"
                                />
                                <button
                                    className="pw-eye"
                                    onClick={() => setShowPw(p => !p)}
                                >
                                    <i
                                        className={
                                            showPw
                                                ? 'ri-eye-off-line'
                                                : 'ri-eye-line'
                                        }
                                    />
                                </button>
                            </div>
                            <div style={{ textAlign: 'right', marginTop: 5 }}>
                                <span
                                    style={{
                                        fontSize: 12,
                                        color: 'var(--primary)',
                                        cursor: 'pointer',
                                        fontWeight: 600,
                                    }}
                                    onClick={() =>
                                        toast(
                                            '등록된 이메일로 비밀번호 재설정 링크를 발송했습니다',
                                            'success',
                                        )
                                    }
                                >
                                    비밀번호 찾기
                                </span>
                            </div>
                        </div>
                        <label
                            className={`check-wrap${checked ? ' checked' : ''}`}
                            onClick={() => setChecked(c => !c)}
                        >
                            <span className="check-box" />
                            <span className="check-label">
                                로그인 상태 유지 (30일)
                            </span>
                        </label>
                        <button
                            className="btn btn-primary btn-lg w-full"
                            style={{ marginTop: 4 }}
                            onClick={doLogin}
                        >
                            로그인
                        </button>
                    </div>

                    <div className="auth-footer">
                        담당 부서 계정 발급 및 권한 문의는{' '}
                        <a
                            onClick={() =>
                                toast(
                                    '관리자 문의: admin@ais-tree.kr',
                                    'success',
                                )
                            }
                        >
                            시스템 관리자
                        </a>
                        에게 연락하세요
                    </div>
                </div>

                <div
                    className="fade-up"
                    style={{
                        animationDelay: '.16s',
                        marginTop: 22,
                        color: 'rgba(255,255,255,0.5)',
                        fontSize: 11,
                        textAlign: 'center',
                        lineHeight: 1.7,
                        position: 'relative',
                        zIndex: 1,
                    }}
                >
                    본 화면은 LH·수프로 제안용 데모 시안입니다 · AIS 스마트
                    수목관리 플랫폼 v1.0
                    <br />
                    센서 기반 · 센서리스 전략 병행 지원 · Copyright ⓒ AIS &amp;
                    수프로
                </div>
            </div>
        </>
    );
}
